<div class="mat-elevation-z8 table-content">
    <div class="mat-elevation-z8">
        <mat-table [dataSource]="managementRequests" matSort [matSortActive]="activeSort"
            [matSortDirection]="sortDirection" (matSortChange)="onSortChange($event)">

            <ng-container matColumnDef="request_number">
                <mat-header-cell *matHeaderCellDef mat-sort-header="request_number">
                    {{ 'certificates.requestNumber' | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{ element.requestNumber }} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="action">
                <mat-header-cell *matHeaderCellDef mat-sort-header="action">
                    {{ 'certificates.action' | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{mapCertificateExecutedAction(element.action)}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="created_on">
                <mat-header-cell *matHeaderCellDef mat-sort-header="created_on">
                    {{ 'businessTexts.requestCreationdate' | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element">{{ element.createdOn | date:'dd.MM.yyyy' }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="certificateHolderName">
                <mat-header-cell *matHeaderCellDef mat-sort-header="certificateHolderName">
                    {{ 'businessTexts.certificateHolderName' | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element">{{ element.certificateHolderName }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef mat-sort-header="status">
                    {{ 'certificates.status' | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{mapCertificateStatus(element.status)}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="requestCreatorFullName">
                <mat-header-cell *matHeaderCellDef>
                    {{ 'businessTexts.requestCreatorFullname' | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element">{{ element.requestCreatorFullName }}</mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
        <mat-paginator #paginator [length]="totalCount" [pageSize]="pageSize" [pageIndex]="pageIndex"
            [pageSizeOptions]="[5, 10, 25, 50, 100]" showFirstLastButtons>
        </mat-paginator>
    </div>